import '../ManageLessons.scss';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { useState } from 'react';

type Props = {
  lessonContent: string;
  handleLessonContent: (lessonContent: string) => void;
};

export const TextLessonField = ({ lessonContent, handleLessonContent }: Props) => {
  const [editorState, setEditorState] = useState(() => {
    if (!lessonContent) {
      return EditorState.createEmpty();
    } else {
      const contentBlock = htmlToDraft(lessonContent);

      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        return editorState;
      }
    }
  });

  return (
    <Editor
      editorState={editorState}
      toolbarClassName='text-editor-toolbar'
      wrapperClassName='text-editor-wrapper'
      editorClassName='text-editor'
      onEditorStateChange={(editorState) => setEditorState(editorState)}
      onChange={() => {
        const convertedContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        const cleanedContent = convertedContent === '<p></p>\n' || convertedContent === '<p></p>' ? '' : convertedContent;

        handleLessonContent(cleanedContent);
      }}
    />
  );
};
